module.exports={
    "needed": {
        "_eol_": ""
    },
    "typos": {
    },
    "needed_20220316": {
        "addressColumnTitle": "Address",
        "bedCountColumnTitle": "Bed Count",
        "canPayForWithHousingSupportLabel": "<p>Housing Support (GRH)</p>",
        "countyColumnTitle": "County",
        "daysSinceModifiedColumnTitle": "Days Since Last Modified",
        "idColumnTitle": "Id",
        "modifiedTimeColumnTitle": "Date Last Modified",
        "organizationNameColumnTitle": "Organization Name",
        "organizationNameColumnTitle": "Organization Name",
        "organizationsEngagementReportTitle": "Organization Engagement",
        "organizationsListReportTitle": "Organization List",
        "phoneColumnTitle": "Phone",
        "primaryContactEmailColumnTitle": "Primary Contact Email",
        "primaryContactNameColumnTitle": "Primary Contact Name",
        "primaryContactPhoneColumnTitle": "Primary Contact Phone",
        "programCountColumnTitle": "Program Count",
        "programNameColumnTitle": "Program Name",
        "programsCountyReportTitle": "Programs By County",
        "programsFilteredReportTitle": "Programs: Your Filters",
        "programsListReportTitle": "Program List",
        "programTypeColumnTitle": "Program Type",
        "saveCsvButton": "Download",
        "totalProgramsPerCountyColumnTitle": "Total Programs",
        "unitCountColumnTitle": "Unit Count",
        "vacancyCountColumnTitle": "Vacancy Count",
        "pleaseSignInLabel": "Please sign in"
    },
    "needed_20200413": {
        "buttonFavoriteTrue": "One of my favorites",
        "buttonFavoriteFalse": "Add to my favorites",
        "buttonFilterRemove": "Remove filter",
        "buttonGeolocate": "Find location",
        "buttonPopoutPrograms": "Open programs in new page",
        "buttonPopoutProgramDetails": "Open program details in new page",
        "buttonSearch": "Search",
        "buttonShareProgram": "Share program",
        "buttonShareCopy": "Copy",
        "buttonShareEmail": "Email",
        "buttonUnitTypes": "Unit Types",
        "foundCountLoading": "Loading...",
        "notifyFilterSetSaved": "Filter set saved.",
        "numberOfComparableUnitsInvalidFeedback": "Minimum value is 1",
        "placesShareProgramDetailsEmailBody": "<p>I wanted to share this program from HB101 Places with you:</p>",
        "placesShareProgramDetailsEmailSubject": "<p>A shared page from HB101 Places</p>",
        "placesShareProgramsEmailBody": "<p>I wanted to share these programs from HB101 Places with you:</p>",
        "placesShareProgramsEmailSubject": "<p>A shared page from HB101 Places</p>",
        "programAddressMustBeInMinnesota": "Program address must be in Minnesota",
        "shareProgramsLabel": "Share Programs",
        "shareProgramsBody": "Share programs, lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "shareProgramDetailsLabel": "Share Program",
        "shareProgramDetailsBody": "Share program details, lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "tabFilters": "Filters",
        "tabMap": "Map",
        "unitTypeTitle": "Unit Type",
        "unitCategoryTypeTitle": "Room Type",
        "vacanciesLabel": "Vacancies",
        "_eol_": ""
    },
    "needed_20200203": {
        "sharedLivingPrompt": "Do you want to live in a shared living location that offers on-site services, such as Board and Lodge or Adult Foster Care?",
        "locationPrompt": "What is the address, city, state, or zip code of your preferred location?",
        "householdTypePrompt": "Who will live in your place?",
        "serviceForDiagnosisTypePrompt": "Do you need services for any of the following? (Select all that apply.)",
        "canServeMAWaiversTypePrompt": "Do you get MA-Waiver benefits?",
        "petPolicyTypePrompt": "Do you have a pet? (That is not a service animal.)",
        "congratulationsPlacesText": "<h2>Congratulations! We have found places in Adult Foster Care and Board and Lodge that might work for you.</h2><p>You will see a list of Adult Foster Care and Board and Lodge programs near you that have vacancies. These will be places that serve people in your situation.</p><p>Make sure to check out the filters &mdash; there are other options you can specify, related to things like meals, sobriety, smoking, languages, and more.</p>",
        "oopsPlacesText": "<h2>Oops! HB101 Housing and Services Search isn’t the right tool for you.</h2><p>This tool only has places in Adult Foster Care and Board and Lodge locations. Based on your answer, we recommend you read HB101’s [Housing Type selected] article.</p><p>If you are looking for an apartment or home in the community, <a href=\"#\">HousingLink.org</a> is a great place to start your search.</p>",
        "signInPrompt": "Please sign in so that you can mark favorite programs and save filters",
        "selectOneOrMorePrompt": "One or more items must be selected",
        "_eol_": ""
    },
    "needed_20200130": {
        "foundProgramSingular": "Found _COUNT_ program",
        "foundProgramsPlural": "Found _COUNT_ programs",
        "quickStartTitle": "Quick Start",
        "administratorsTitle": "Administrators",
        "administratorTitle": "Administrator",
        "reportsTitle": "Reports",
        "buttonResumeEdit": "Resume Edit",
        "buttonCancelEdit": "Cancel Edit",
        "buttonExit": "Exit",
        "_eol_": ""
    },
    "needed_20191017": {
        "address1Label": "Address 1",
        "address2Label": "Address 2",
        "addressLookupLabel": "Address lookup",
        "findLabel": "Find",
        "keywordsTitle": "Find",
        "listingLabel": "Listing",
        "myFavoritesTitle": "My favorites",
        "myProgramsTitle": "My programs",
        "noContactsLabel": "No contacts...",
        "noImagesLabel": "No pictures...",
        "noVacanciesLabel": "No vacancies...",
        "organizationNameLabel": "Organization name",
        "programNameLabel": "Program name",
        "roleLabel": "Role",
        "_eol_": ""
    },
    "needed_20190828": {
        "buttonDailyLife": "Daily Life",
        "buttonDashboard": "Dashboard",
        "buttonDetails": "Details",
        "buttonEdit": "Edit",
        "buttonLocation": "Location",
        "buttonPictures": "Pictures",
        "buttonPrevious": "Previous",
        "buttonPrograms": "Programs",
        "buttonRules": "Rules",
        "buttonSaveAs": "Save as",
        "buttonServices": "Services",
        "buttonUnits": "Units",
        "deleteLabel": "Delete",
        "distanceTitle": "Distance",
        "filterSetLabel": "filter set",
        "filtersTitle": "Filters",
        "foundLabel": "Found",
        "milesLabel": "miles",
        "programsLabel": "programs",
        "sortByLabel": "Sort by",
        "summaryTitle": "Summary",
        "_eol_": ""
    },
    "needed_20190601_0655": {
        "descriptionLabel": "Description",
        "milesFromLabel": "miles from",
        "noWaitingListLabel": "No waiting list",
        "publicAdminHeaderTitle": "HB101 Housing with Services Search",
        "publicAdminHeaderBlurb": "Find housing that comes with client focused services. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
        "publicSidebarVacancyAvailable": "Has vacancies",
        "programTypeBoardAndLodgeWithServices": "Board and lodge with services",
        "programTypeBoardandLodgeWithoutServices": "Board and lodge without services",
        "programTypeAdultFosterCare": "Adult foster care",
        "unitsAvailableNowLabel": "units available now",
        "waitingListLabel": "Waiting list",
        "_eol_": ""
    },
    "typos_20190601_0702": {
        "kitchenTypeClientsCanCookInASharedKitchen": "Can cook in ashared kitchen"
    }
}
